export const journeySlice = set => ({
  journey: 'unique',
  setJourney: journey => set(() => ({ journey })),
})
